import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { authresponse } from '@interfaces';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { map } from 'rxjs/operators';

import {
  IApiBiometricVerificationResponseInterface,
} from '@app/account-opening-module/interfaces';
import { BiometricVerifiedDocumentModel } from '@app/account-opening-module/models';

@Injectable({
  providedIn: 'root'
})
export class GuestBiometricService {
  checkStatus(_operationId: string): import("rxjs").ObservableInput<unknown> {
    throw new Error('Method not implemented.');
  }
  private apiUrl = `${environment.apiUrl}validate_code`;
  private Url = environment.apiUrl;
  constructor(private http: HttpClient) {}

  requestToken(name: any, email: any) : Observable<any> {
    return this.http.post<any>(`${this.Url}/active_login/token`, { name, email });
  }

  public initiateBiometricVerification(requestId:any, email:any, documentType: any, token: any, role: string): Observable<IApiBiometricVerificationResponseInterface> {
    const body = 'requestId=' + requestId + '&email='+email + "&documentType=" + documentType + "&role=" + role;
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/x-www-form-urlencoded'
    });
  return this.http.post<IApiBiometricVerificationResponseInterface>(this.Url + 'v1/biometric-identity/assessments/initiate?'+body, {}, {"headers": headers});
}


  public biometricVerifiedDocument(operationId: string): Observable<BiometricVerifiedDocumentModel> {
    return this.http.get<object>(this.Url + `v1/biometric-identity/operations/${operationId}`)
      .pipe(
        map(response => response['Data']['Document']),
        map(document => new BiometricVerifiedDocumentModel(document['Data'], document['Type'], document['BlackIceIdentifier']))
      );
  }

  getDataByCode(code: string | undefined): Observable<authresponse> {
    return this.http.post<authresponse>(`${this.apiUrl}`, { code });
  }

  getRequest(requestId: string) : Observable<object> {
    console.log(`${this.Url}/assessment_requests/${requestId}`);
    return this.http.get<object>(`${this.Url}/assessment_requests/${requestId}`);
  }
  
  getRequestWithRole(requestId: string, role: string) : Observable<object> {
    console.log(`${this.Url}/${role}/assessment_requests/${requestId}`);
    return this.http.get<object>(`${this.Url}/${role}/assessment_requests/${requestId}`);
  }
}  
